import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { useOnClickOutside } from '@famly/stat_use-on-click-outside';
import { ModalDialogProvider } from '@famly/mf_modals-dialogs_context';
import { dayPickerInputPortalContentClassName } from '../components/form-elements/daypicker/day-picker-input-portal-class-name';
import { StyledModalPortal } from './styled-modal-portal';
const StyledModalContent = styled.span `
    ${props => (props.fullHeight ? 'height: 100%;' : '')}
`;
const defaultIgnoreOutsideClickSelector = [
    `.${dayPickerInputPortalContentClassName}`,
    '.MuiPickersPopper-root',
    '.MuiInputBase-input',
];
export function ModalWrapper(modal) {
    const modalRef = React.useRef(null);
    const handleClickOutside = React.useCallback(() => {
        if (modal.isTopMostModal) {
            modal.handleHide();
        }
    }, [modal]);
    const combinedIgnoreOutsideClickSelectors = React.useMemo(() => {
        var _a;
        return [...defaultIgnoreOutsideClickSelector, ...((_a = modal.ignoreOutsideClickSelectors) !== null && _a !== void 0 ? _a : [])];
    }, [modal.ignoreOutsideClickSelectors]);
    useOnClickOutside(modalRef, handleClickOutside, combinedIgnoreOutsideClickSelectors);
    return (_jsx(StyledModalPortal, { ...modal.modalProps, ...modal.modalStyle, children: _jsx(ModalDialogProvider, { children: _jsx(StyledModalContent, { fullHeight: modal.contentFullHeight, ref: modalRef, children: React.createElement(modal.component, modal.props) }) }) }));
}
